module.exports = __webpack_public_path__ + "img/poster-1.65a72106.jpg";